import React from 'react';
const links = [{
  label: 'AGB',
  href: '#agb'
}, {
  label: 'Datenschutz',
  href: '#datenschutz'
}, {
  label: 'Kontakt',
  href: '#kontakt'
}, {
  label: 'Impressum',
  href: '#impressum'
}];
export function Footer() {
  return <footer className="bg-brand-navydeep px-5 py-12 text-center text-sm text-white/60" data-id="element-66" data-mp="32pff8bhdzhy6">
      <div className="mx-auto max-w-[1100px]" data-id="element-67" data-mp="36q9354utwwr2">
        <p className="font-display text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-68" data-mp="36n3grxdl48z1">
          <span aria-hidden="true" data-id="element-69" data-mp="3ud7iu0b4k0nx">🎵</span> Musik Startklar
        </p>
        <p className="mt-2 text-xs text-white/50" data-id="element-70" data-mp="387g3ogsjfgb">
          Das komplette Musik-Curriculum
        </p>
        <nav aria-label="Rechtliches" className="mb-8 mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-71" data-mp="3le2j4qntu1a6">
          {links.map(link => <a key={link.label} href={link.href} className="transition-colors duration-150 ease-out hover:text-white" data-id="element-72" data-mp="29ydrvn3jig3k">
              {link.label}
            </a>)}
        </nav>
        <p className="text-xs" data-id="element-73" data-mp="3gagzjp259b3q">
          © 2026 Musik Startklar. Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>;
}